import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { AuthTokenRefreshService } from '../services/auth-token-refresh.service';

@Injectable()
export class GlobalHttpInterceptorServiceInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private tokenRefresh: AuthTokenRefreshService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const prepared = this.prepareRequest(request);

    return next.handle(prepared).pipe(
      catchError((error: HttpErrorResponse) => {
        if (!this.tokenRefresh.shouldAttemptRefresh(prepared, error)) {
          if (error.status === 401 && !prepared.url.toLowerCase().includes('/platform/auth')) {
            this.authService.clearSessionAndRedirect();
          }
          return throwError(error);
        }

        return this.tokenRefresh.refreshToken().pipe(
          switchMap(() =>
            next.handle(this.tokenRefresh.cloneRequestWithUpdatedToken(prepared))
          ),
          catchError((refreshError) => {
            this.authService.clearSessionAndRedirect();
            return throwError(refreshError);
          })
        );
      })
    );
  }

  private prepareRequest(request: HttpRequest<unknown>): HttpRequest<unknown> {
    let prepared = request;
    const token = localStorage.getItem('token');

    if (token) {
      prepared = prepared.clone({
        setHeaders: {
          Authorization: 'Bearer ' + token,
        },
      });
    }

    if (!prepared.headers.has('Content-Type')) {
      prepared = prepared.clone({
        setHeaders: {
          'content-type': 'application/json',
        },
      });
    }

    return prepared.clone({
      headers: prepared.headers.set('Accept', 'application/json'),
    });
  }
}
